import { Injectable } from '@angular/core';
import { AdminApiClient } from '@/lib-backend';
import { SessionAdminApiClient } from '@/lib-backend/SessionAdminApiClient';
import { IHttpTransport } from '@/lib-backend/core/types';
import { environment } from '@/environments/environment';
import { HttpTransportError } from '@/app/utils/http-errors';

/** Fetch transport that disables browser/CDN caching */
const noCacheTransport: IHttpTransport = {
    async post(url: string, body: unknown, headers: Record<string, string>): Promise<unknown> {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(body),
            cache: 'no-store',
        });
        try {
            return await response.json();
        } catch {
            // The API signals handled errors as HTTP 200 + a JSON envelope, so a
            // non-JSON body here means an infrastructure rejection (e.g. an nginx /
            // Kestrel HTML error page on 413 Content Too Large). Surface the HTTP
            // status as a typed error instead of letting the JSON parse failure
            // bubble up as a misleading "Unexpected token '<'" SyntaxError.
            throw new HttpTransportError(response.status);
        }
    },
};

@Injectable({ providedIn: 'root' })
export class ApiService {
    readonly client = new SessionAdminApiClient(environment.apiBaseUrl, noCacheTransport);
    /** Direct client without session management — use for pre-session calls (e.g. token refresh on startup). */
    readonly rawClient = new AdminApiClient(environment.apiBaseUrl, noCacheTransport);
}
